module.exports = __webpack_public_path__ + "static/media/arts_13.8a67aff8.jpg";